import { copy_standard_attributes } from "../../../helpers/copy_standard_attributes";
import { Snippet } from "./Snippet";
export class KeybindSnippet extends Snippet {
    constructor() {
        super(...arguments);
        this.keybind = "";
    }
    copy() {
        let newValue = new KeybindSnippet(this.id);
        newValue.keybind = this.keybind;
        copy_standard_attributes(this, newValue);
        return newValue;
    }
    editor_fields() {
        return [{
                field: "keybind",
                placeholder: "Keybind",
                datalistID: "datalist-keybinds",
                fieldType: "string"
            }];
    }
}
